/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'fabric.elements.mentions.team.member.50plus': 'Team • flere enn 50 medlemmer',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Team • flere enn 50 medlemmer, inkludert deg',
  'fabric.elements.mentions.team.member.count': '{0, plural, one {Team • 1 medlem} other {Team • {0} medlemmer}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, one {Team • 1 medlem, inkludert deg} other {Team • {0} medlemmer, inkludert deg}}',
  'fabric.elements.mentions.xproduct.mention.description': 'Trenger tilgang til Confluence',
  'fabric.mention.error.defaultAction': 'Prøv igjen om noen øyeblikk',
  'fabric.mention.error.defaultHeadline': 'Det oppsto en feil',
  'fabric.mention.error.differentText': 'Prøv med å skrive inn annen tekst',
  'fabric.mention.error.loginAgain': 'Prøv å logge av og deretter på igjen',
  'fabric.mention.noAccess.label': 'Ingen tilgang',
  'fabric.mention.noAccess.warning': '{name} blir ikke varslet, da de ikke har tilgang',
  'fabric.mention.unknow.user.error': 'Ukjent bruker {userId}'
};